<template>
    <div>        
        <list :label="$t('jobs')" v-bind:refresh="this.refresh" table='scraper' v-bind:hideNewAndEdit="true" v-on:childMessage="onMessageFromListReceived" initialSortBy="starttimescraper" :initialSortDesc="true"></list>
    </div>
</template>

<script>

import List from "@/components/List"
import Api from "@/Api"
import { Utils } from "@/Utils"

export default {
    components:
    {
        List
    },

    data()
    {
        return {
            showDialog: "",
            fields: [],
            refresh: 0,
            title: "",
            text: ""
        };
    },

    props: [],

    mixins: [Utils],

    created()
    {
    },

    methods:
    {
        onMessageFromListReceived (message)
        {
            if (message.cmd === "delRecord")
            {
                const id = message.item["id"];
                const self = this;
                Api.deleteRecord("scraper", id).then(function(result)
                {
                    if (result.status === 200)
                    {
                        self.refresh += 1;
                    }
                    else
                        alert (self.$t("action not possible"));

                })
                .catch((e) =>
                {
                    alert (self.$t("action not possible"));
                });
            }
        }
    }
};
</script>